import { z } from 'zod';
export const projectsTimeReferenceCapability = 'projects.time-reference.v1';
export const projectsTimeReferenceSnapshotSchema = z.strictObject({
    contractVersion: z.literal(projectsTimeReferenceCapability),
    projectId: z.string().uuid(),
    label: z.string().trim().min(1).max(500),
    projectRevision: z.number().int().positive(),
});
//# sourceMappingURL=projects-time-reference.contract.js.map